/*
 * @Description: Preview Components
 * @Author: Jack Deng
 * @Date: 2021-03-09 15:58:23
 * @LastEditors: Json Chen

 * @LastEditTime: 2021-10-18 14:00:59

 * @LastEditTime: 2021-03-12 17:08:53

 * @LastEditTime: 2021-03-12 18:27:23

 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Preview/index.tsx
 */
import { Icon } from '@/src/tools/icon';
import { GlobalOutlined } from '@ant-design/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { FloatingActionsBars } from 'unifyxp-ecomm-components';
import styles from './style.module.less';
import { Module, ModuleList } from './util';

type Props = {
  order: Array<Module>;
  getContent: any;
  getIconStyle?: any;
  getCollapseStatus: any;
  getFloatingActionsBar?: any;
  onCollapseOpen?;
};

function Preview({
  order,
  getContent,
  getIconStyle,
  getCollapseStatus,
  getFloatingActionsBar,
  onCollapseOpen,
}: Props) {
  const rawData = {
    moduleContentOrder: order,
  };
  const iconStyle = getIconStyle
    ? useSelector(getIconStyle())
    : useSelector((state: any) => state.salesChannelContent.homepage.iconStyle);
  const floatingBar = getFloatingActionsBar
    ? useSelector(getFloatingActionsBar())
    : useSelector(
        (state: any) => state.salesChannelContent.homepage.floatingBar,
      );

  return (
    <div className={styles.previewContainer}>
      <div className={styles.container}>
        <ModuleList
          rawData={rawData}
          getContent={getContent}
          getCollapseStatus={getCollapseStatus}
          onCollapseOpen={onCollapseOpen}
        />
        <FunctionBar color={iconStyle.colour} />
      </div>
      <FloatingActionsBars
        {...floatingBar}
        onClick={(btn) => {
          console.log(btn);
        }}
      />
    </div>
  );
}

export default Preview;

function FunctionBar({ color = '#fff' }: { color?: string }) {
  return (
    <div className={styles.functionContainer}>
      <Icon type='iconlanguageCopy' className={styles.icon} style={{ color }} />
      <GlobalOutlined className={styles.icon} style={{ color }} />
    </div>
  );
}
